export default "__VITE_ASSET__DKGJqJ05__"